import { render, staticRenderFns } from "./TruncatedTooltip.vue?vue&type=template&id=20193469&"
import script from "./TruncatedTooltip.vue?vue&type=script&lang=js&"
export * from "./TruncatedTooltip.vue?vue&type=script&lang=js&"
import style0 from "./TruncatedTooltip.vue?vue&type=style&index=0&id=20193469&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports